import React, { useState, useContext, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  customStyle,
  tableLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { UserContext } from "../../../../../contexts/User";
import { FinanceContext } from "../../../../../contexts/Finance";
import { RestaurantContext } from "../../../../../contexts/Restaurant";

const SupplierAction = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { id } = useParams();
    //getting context values here
    let {
      //common
      loading,
      setLoading,
    } = useContext(SettingsContext);

    const { cao3Active, coa3ForSearch, getCoaL3 } = useContext(FinanceContext);
  
    let {
      setSupplierList,
      setSupplierForSearch,
      setSupplierStatusForSearch,
      //pagination
    } = useContext(UserContext);

    const { ingredientItemForSearch } = useContext(RestaurantContext)

    //new customer
    let [newSupplier, setNewSupplier] = useState({
        company_name: "",
        contact_person: "",
        account_code: "",
        food_safety_certification:"",
        delivery_terms:"",
        email: "",
        phn_no: "",
        address: "",
        desc:"",
        coa: null,
        items:[],
        due: null,
        edit: false,
        editSlug: null,
        uploading: false,
    });

    //set name, phn no hook
    const handleSetNewSupplier = (e) => {
        setNewSupplier({ ...newSupplier, [e.target.name]: e.target.value });
    };

    const handleSetIngredients = (items)=>{
        setNewSupplier({ ...newSupplier, items });
    }

    useEffect(()=>{
        if(id){
            handleSetEdit()
        }
        if(!cao3Active){
            getCoaL3();
        }
    },[id]);

    const handleSetSelect = (key,value)=>{
        setNewSupplier((curr)=>({
          ...curr,
          [key]: value,
        }));
    }

    //Save New customer
    const handleSaveNewCustomer = (e) => {
        e.preventDefault();
        setNewSupplier({
        ...newSupplier,
        uploading: true,
        });
        const items = newSupplier.items && newSupplier.items?.length ? newSupplier.items.map(item=> item.id) : null;
        const customerUrl = BASE_URL + `/settings/new-supplier`;
        let formData = new FormData();
        formData.append("name", newSupplier.company_name);
        formData.append("contact_person", newSupplier.contact_person);
        formData.append("ingredient_item", items?.length ? (items) : "");
        formData.append("phn_no", newSupplier.phn_no);
        formData.append("email", newSupplier.email);
        formData.append("delivery_terms", newSupplier.delivery_terms);
        formData.append("account_code", newSupplier.account_code)
        formData.append("food_safety_certification", newSupplier.food_safety_certification);
        formData.append("address", newSupplier.address);
        formData.append("due", 0);
        formData.append("description", newSupplier.desc);
        formData.append("supplier_coa_id", newSupplier?.coa?.id ?? "");
        formData.append("supplier_coa_name", newSupplier?.coa?.level3_name ?? "");
        
        return axios
        .post(customerUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
            setNewSupplier({
                company_name: "",
                contact_person: "",
                email: "",
                phn_no: "",
                account_code:"",
                food_safety_certification:"",
                delivery_terms:"",
                address: "",
                coa: null,
                items:[],
                desc:"",
                due: null,
                edit: false,
                editSlug: null,
                uploading: false,
            });
            setSupplierList(res.data[0]);
            setSupplierStatusForSearch(res.data[1]);
            setSupplierForSearch(res.data[2]);
            setLoading(false);
            toast.success(`${_t(t("Supplier has been added"))}`, {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
            history.push("/dashboard/manage/stock/manage-supplier")
        })
        .catch((error) => {
            setLoading(false);
            setNewSupplier({
            ...newSupplier,
            uploading: false,
            });
            if (error && error.response.data.errors) {
            if (error.response.data.errors.phn_no) {
                error.response.data.errors.phn_no.forEach((item) => {
                if (item === "A supplier exists with this phone number") {
                    toast.error(
                    `${_t(t("A supplier exists with this phone number"))}`,
                    {
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                    }
                    );
                }
                });
            }
            }
        });
    };

    const getIngredientSupplier = async() =>{
        const url = BASE_URL + "/settings/edit-supplier/" + id
        try{
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            })
            return res.data;
        }catch(err){
            toast.error(
                `${_t(t("Failed to fetch supplier"))}`,{
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
        }
    }

    //set edit true & values
    const handleSetEdit = async() => {
        let supplier = await getIngredientSupplier();
        const coa = supplier?.supplier_coa_id ? coa3ForSearch.find((coa)=> coa.id === supplier.supplier_coa_id) : "";

        setNewSupplier({
            ...newSupplier,
            company_name: supplier.name,
            contact_person: supplier.contact_person,
            items: supplier.ingredient_items,   
            email: supplier.email !== "-" ? supplier.email : "",
            phn_no: supplier.phn_no,
            coa,
            account_code: supplier.account_code,
            food_safety_certification: supplier.food_safety_certification,
            delivery_terms: supplier.delivery_terms,
            address: supplier.address,
            desc: supplier.description,
            due: supplier.due_balance,
            editSlug: supplier.slug,
            edit: true,
        });
    };

    //update customer
    const handleUpdateCustomer = (e) => {
        e.preventDefault();
        setNewSupplier({
        ...newSupplier,
        uploading: true,
        });
        const items = newSupplier.items && newSupplier.items?.length ? newSupplier.items.map(item=> item.id) : null;
        const customerUrl = BASE_URL + `/settings/update-supplier`;
        let formData = new FormData();
        formData.append("id", id);
        formData.append("name", newSupplier.company_name);
        formData.append("contact_person", newSupplier.contact_person);
        formData.append("phn_no", newSupplier.phn_no);
        formData.append("ingredient_item", items?.length ? (items) : "");
        formData.append("email", newSupplier.email);
        formData.append("account_code", newSupplier.account_code)
        formData.append("food_safety_certification", newSupplier.food_safety_certification);
        formData.append("delivery_terms", newSupplier.delivery_terms);
        formData.append("address", newSupplier.address);
        formData.append("due", 0);
        formData.append("description", newSupplier.desc);
        formData.append("supplier_coa_id", newSupplier?.coa?.id ?? "");
        formData.append("supplier_coa_name", newSupplier?.coa?.level3_name ?? "");

        return axios
        .post(customerUrl, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
            setNewSupplier({
                name: "",
                contact_person:"",
                email: "",
                phn_no: "",
                coa: null,
                address: "",
                account_code: "",
                food_safety_certification:"",
                delivery_terms:"",
                desc:"",
                items: [],
                due: null,
                edit: false,
                editSlug: null,
                uploading: false,
            });
            setSupplierList(res.data[0]);
            setSupplierStatusForSearch(res.data[1]);
            setSupplierForSearch(res.data[2]);
            setLoading(false);
            toast.success(`${_t(t("Supplier has been updated"))}`, {
                position: "bottom-center",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                className: "text-center toast-notification",
            });
            history.push("/dashboard/manage/stock/manage-supplier")
        })
        .catch((error) => {
            setLoading(false);
            setNewSupplier({
            ...newSupplier,
            uploading: false,
            });
            if (error && error.response.data.errors) {
            if (error.response.data.errors.phn_no) {
                error.response.data.errors.phn_no.forEach((item) => {
                if (item === "A supplier exists with this phone number") {
                    toast.error(
                    `${_t(t("A supplier exists with this phone number"))}`,{
                        position: "bottom-center",
                        autoClose: 10000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        className: "text-center toast-notification",
                    });
                }});
            }}
        });
    };

  return (
    <>
        <Helmet>
            <title>{id ? _t(t("Update Supplier")) : _t(t("Add New Supplier"))}</title>
        </Helmet>

        {/* main body */}
        <main id="main" data-simplebar>
            <div className="container-fluid">
                <div className="row t-mt-10 gx-2">
                    {/* left Sidebar */}
                    <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                        <ManageSidebar />
                    </div>
                    {/* left Sidebar ends */}

                    {/* Rightbar contents */}
                    <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                        <div className="t-bg-white">
                            <div
                                className="fk-scroll--pos-menu table-bottom-info-hide"
                                data-simplebar
                            >
                                <div className="t-pl-15 t-pr-15">

                                    {/* Loading effect */}
                                    {loading === true ? (
                                        tableLoading()
                                    ) : (
                                        <div key="smtp-form">
                                            <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                                                <div className="col-12 t-mb-15 mb-md-0">
                                                    <ul className="t-list fk-breadcrumb">
                                                        <li className="fk-breadcrumb__list">
                                                            <span className="t-link fk-breadcrumb__link text-capitalize">
                                                                {id ? _t(t("Update Supplier")) :_t(t("Add New Supplier"))}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>

                                            {/* Form starts here */}
                                            <form
                                                className="row card p-2 mx-3 mb-5 table-text"
                                                onSubmit={
                                                    !newSupplier.edit
                                                    ? handleSaveNewCustomer
                                                    : handleUpdateCustomer
                                                }
                                                autoComplete="off"
                                            >
                                                 <div className="col-12">
                                                    <div className="row">
                                                        <div className="form-group col-6 mt-3">
                                                            <label htmlFor="company_name" className="form-label">
                                                            {_t(t("Company Name"))}{" "}
                                                            <small className="text-danger">*</small>
                                                            </label>
                                                            <input
                                                            type="text"
                                                            className="form-control"
                                                            id="company_name"
                                                            name="company_name"
                                                            placeholder="A & Y Foods"
                                                            value={newSupplier.company_name || ""}
                                                            required
                                                            onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                        <div className="form-group col-6 mt-3">
                                                            <label htmlFor="contact_person" className="form-label">
                                                            {_t(t("Contact Person"))}{" "}
                                                            </label>
                                                            <input
                                                            type="text"
                                                            className="form-control"
                                                            id="contact_person"
                                                            name="contact_person"
                                                            placeholder="Asif"
                                                            value={newSupplier.contact_person || ""}
                                                            onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="form-group col-6 mt-3">
                                                            <label htmlFor="phn_no" className="form-label">
                                                            {_t(t("Phone number"))}{" "}
                                                            <small className="text-danger">*</small>
                                                            </label>
                                                            <input
                                                            type="text"
                                                            className="form-control"
                                                            id="phn_no"
                                                            name="phn_no"
                                                            placeholder="03xx xxxx xxx"
                                                            value={newSupplier.phn_no || ""}
                                                            required
                                                            onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                        <div className="form-group col-6 mt-3">
                                                            <label htmlFor="email" className="form-label">
                                                            {_t(t("Email"))}{" "}
                                                            {/* <small className="text-danger">*</small> */}
                                                            </label>
                                                            <input                        
                                                            type="email"
                                                            className="form-control"
                                                            id="email"
                                                            name="email"
                                                            placeholder="supplier@example.com"
                                                            value={newSupplier.email || ""}
                                                            onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                    </div>
                                                   
                                                    <div className="mt-3">
                                                        <label htmlFor="address" className="form-label">
                                                        {_t(t("Address"))}{" "}
                                                        {/* <small className="text-danger">*</small> */}
                                                        </label>
                                                        <textarea
                                                        // required
                                                        type="text"
                                                        className="form-control"
                                                        id="address"
                                                        name="address"
                                                        placeholder="Type customer address"
                                                        value={newSupplier.address || ""}
                                                        onChange={handleSetNewSupplier}
                                                        />
                                                    </div>
                                                
                                                    <div className="mt-3">
                                                        <label htmlFor="desc" className="form-label">
                                                        {_t(t("Description"))}{" "}
                                                        {/* <small className="text-danger">*</small> */}
                                                        </label>
                                                        <textarea
                                                        // required
                                                        type="text"
                                                        className="form-control"
                                                        id="desc"
                                                        name="desc"
                                                        placeholder="Type Description"
                                                        value={newSupplier.desc || ""}
                                                        onChange={handleSetNewSupplier}
                                                        />
                                                    </div>

                                                    <div className="row">
                                                        <div className="mt-3 col-6">
                                                            <label htmlFor="account_code" className="form-label">
                                                            {_t(t("Account Code"))}{" "}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="account_code"
                                                                name="account_code"
                                                                placeholder="e.g c-120"
                                                                value={newSupplier.account_code || ""}
                                                                onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                        <div className="mt-3 col-6">
                                                            <label htmlFor="food_safety_certification" className="form-label">
                                                            {_t(t("Food Certification"))}{" "}
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="food_safety_certification"
                                                                name="food_safety_certification"
                                                                placeholder="e.g iso"
                                                                value={newSupplier.food_safety_certification || ""}
                                                                onChange={handleSetNewSupplier}
                                                            />
                                                        </div>
                                                    </div>


                                                    <div className="mt-3">
                                                        <label htmlFor="delivery_terms" className="form-label">
                                                        {_t(t("Terms and Conditions"))}{" "}
                                                        </label>
                                                        <textarea
                                                            type="text"
                                                            className="form-control"
                                                            id="delivery_terms"
                                                            name="delivery_terms"
                                                            placeholder="Type condititon"
                                                            value={newSupplier.delivery_terms || ""}
                                                            onChange={handleSetNewSupplier}
                                                        />
                                                    </div>

                                                    <hr className="mt-4"/>
                                                    <div className="row">
                                                        <div className="mt-3 col-4">
                                                            <label htmlFor="_unit" className="form-label">
                                                            {_t(t("Account"))}
                                                            </label>
                                                            <Select
                                                            options={cao3Active ?? []}
                                                            value={newSupplier.coa}
                                                            getOptionLabel={(option) => option.level3_name}
                                                            getOptionValue={(option) => option.id}
                                                            classNamePrefix="select"
                                                            isClearable
                                                            styles={customStyle}
                                                            onChange={(coa) => handleSetSelect("coa", coa)}
                                                            maxMenuHeight="200px"
                                                            placeholder={
                                                                _t(t("Please select coa")) + ".."
                                                            }
                                                            />
                                                        </div>
                                                        <div className="mt-3 col-8">
                                                            <label htmlFor="address" className="form-label">
                                                            {_t(t("Ingredient Items"))}
                                                            </label>
                                                            <Select
                                                                menuPlacement="top"
                                                                menuPosition="fixed"
                                                                options={ingredientItemForSearch ? ingredientItemForSearch : []}
                                                                getOptionLabel={(option) => option.name}
                                                                getOptionValue={(option) => option.id}
                                                                classNamePrefix="select"
                                                                className="xsm-text"
                                                                value={newSupplier.items}
                                                                onChange={handleSetIngredients}
                                                                maxMenuHeight="200px"
                                                                styles={customStyle}
                                                                isMulti
                                                                isClearable
                                                                placeholder={_t(t("Select items")) + ".."}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-group mt-4 pb-2">
                                                        <div className="d-flex justify-content-end align-items-center">
                                                            <div className="col-3 d-flex justify-content-end">
                                                                <button
                                                                    type="button"
                                                                    className="btn rounded hov-btn mr-3"
                                                                    onClick={() => (history.push("/dashboard/manage/stock/manage-supplier"))}
                                                                //   data-dismiss="modal"
                                                                >
                                                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                                                </button>
                                                                <button
                                                                    disabled={loading || newSupplier.uploading}
                                                                    type="submit"
                                                                    className="btn btn-primary rounded"
                                                                >
                                                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>        
                                            </form>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Rightbar contents end*/}
                </div>
            </div>
        </main>
        {/* main body ends */}
    </>
  )
}

export default SupplierAction